import { render, staticRenderFns } from "./ObjectsMenu.vue?vue&type=template&id=75f9e7dc&"
import script from "./ObjectsMenu.vue?vue&type=script&lang=js&"
export * from "./ObjectsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports